import { InterfaceIcon, getSvgIcon } from '@helpers/icons';
import { BackgroundVariant } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import * as React from 'react';
import S from './Breadcrumbs.styles';
const Breadcrumbs = (props) => {
    if (!props.items || props.items.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { variant: BackgroundVariant.White, translations: props.translations },
        React.createElement(S.List, { "aria-label": props.translations?.['global.breadcrumb.label'] ?? '' }, props.items.map((item, i) => (React.createElement(React.Fragment, { key: `breadcrumb-${i}` },
            React.createElement(S.Item, { key: `breadcrumb-${i}`, "data-hidden": !(i === props.items.length - 1 || i === props.items.length - 2) },
                React.createElement(S.ItemLink, { href: item.url, title: item.text, "aria-current": i === props.items.length - 1 ? 'page' : undefined }, item.text),
                i !== props.items.length - 1 && React.createElement("span", null, getSvgIcon(InterfaceIcon.Chevron)))))))));
};
export default Breadcrumbs;
